<template>
  <div>
    <Card>
      <a-form layout="inline">
        <a-form-item style="margin-bottom: 20px">
          <a-input v-model="dataForm.name" placeholder="设备名称"> </a-input>
        </a-form-item>
        <a-form-item>
          <a-button @click="getDataList" type="primary"> 搜索 </a-button>
        </a-form-item>
        <a-form-item>
          <a-button
            @click="addOrUpdateHandle()"
            v-permission="['device:inspect:add']"
          >
            新增
          </a-button>
        </a-form-item>
      </a-form>
      <a-table
        :columns="columns"
        :data-source="dataList"
        :pagination="false"
        :loading="dataListLoading"
      >
        <span slot="action" slot-scope="text, record">
          <a-space>
            <a-button
              size="small"
              type="link"
              @click="addOrUpdateHandle(record.id)"
              v-permission="['device:inspect:edit']"
              >编辑
            </a-button>
            <a-button
              size="small"
              type="link"
              @click="deleteHandle(record.id)"
              v-permission="['device:inspect:delete']"
              >删除</a-button
            >
          </a-space>
        </span>
        <span slot="create_time" slot-scope="text">
          {{ moment(text).format("YYYY-MM-DD HH:mm:ss") }}
        </span>
      </a-table>
      <a-pagination
        style="margin-top: 20px; float: right"
        show-size-changer
        :current="page"
        show-quick-jumper
        :total="total"
        @showSizeChange="showSizeChange"
        @change="pageCurrentChangeHandle"
        :show-total="(total) => `共 ${total} 条`"
      />
    </Card>
    <addOrUpdate ref="addOrUpdate" @ok="getDataList"></addOrUpdate>
  </div>
</template>

<script>
import viewModule from "@/mixins/view-module";
import addOrUpdate from "./components/inspectaddorupdate.vue";
import moment from "moment";
export default {
  components: { addOrUpdate },
  mixins: [viewModule],
  data() {
    return {
      columns: [
        {
          title: "名称",
          align: "center",
          dataIndex: "name",
          key: "name",
        },
        {
          title: "设备编号",
          align: "center",
          dataIndex: "sn",
          key: "sn",
          // scopedSlots: { customRender: 'project_name' },
        },
        {
          title: "备注",
          align: "center",
          dataIndex: "remark",
          key: "remark",
        },
        {
          title: "创建时间",
          align: "center",
          dataIndex: "create_time",
          key: "create_time",
          scopedSlots: { customRender: "create_time" },
        },
        {
          title: "操作",
          key: "action",
          align: "center",
          scopedSlots: { customRender: "action" },
        },
      ],
      mixinViewModuleOptions: {
        getDataListURL: "/inspect/page",
        deleteURL: "/inspect/delete",
      },
      dataForm: { name: "" },
    };
  },
  methods: {
    moment,
  },
};
</script>

<style></style>